import { Button } from '@octopus-do/octopus-storybook'
import type React from 'react'

type Props = {
  name: string
  cancelButton: React.ReactNode
  confirmCb: () => void
}

export const DeleteTab: React.FC<Props> = ({
  name,
  cancelButton,
  confirmCb,
}) => (
  <div className="System-dialog__inner">
    <div className="System-dialog__title">Delete board</div>

    <div className="System-dialog__description">
      <p>{name} will be deleted. Are you sure?</p>
    </div>

    <div className="System-dialog__buttons">
      <div className="System-dialog__buttons-item">
        <Button
          tone="danger"
          size="medium"
          label="Delete"
          onClick={confirmCb}
        />
      </div>

      <div className="System-dialog__buttons-item">{cancelButton}</div>
    </div>
  </div>
)
